import { Alert, Box, Grid, Link as MuiLink, Stack, styled, Typography, useTheme } from '@mui/material'
import Back from 'components/Back'
import { ContainerWrapper } from 'pages/Creator/StyledCreate'
import { RowCenter } from 'pages/DaoInfo/Children/Proposal/ProposalItem'
import { ChainId, ChainListMap } from 'constants/chain'
import { useParams } from 'react-router'
import { useAirdropAccountListById, useGetAirdropDescData, useGetAirdropProof } from 'hooks/useBackedActivityServer'
import DelayLoading from 'components/DelayLoading'
import Loading from 'components/Loading'
import ReactHtmlParser from 'react-html-parser'
import 'react-quill/dist/quill.snow.css'
import { escapeAttrValue, filterXSS } from 'xss'
import { ActivityStatus, AirdropInfoProp, useAirdropClaimed, useAirdropInfos } from 'hooks/useActivityInfo'
import { getEtherscanLink, shortenAddress } from 'utils'
import Copy from 'components/essential/Copy'
import isZero from 'utils/isZero'
import { Link } from 'react-router-dom'
import { routes } from 'constants/routes'
import { timeStampToFormat } from 'utils/dao'
import OutlineButton from 'components/Button/OutlineButton'
import { useActiveWeb3React } from 'hooks'
import AirdropCollectModal from './AirdropCollectModal'
import { BlackButton } from 'components/Button/Button'
import DownloadIcon from '@mui/icons-material/Download'
import { useCallback, useEffect, useMemo, useState } from 'react'
import AirdropTable from 'pages/DaoInfo/Children/Activity/AirdropTable'
import BigNumber from 'bignumber.js'
import { tryParseAmount } from 'utils/parseAmount'
import {
  useAirdropDownloadCallback,
  useClaimAirdropCallback,
  usePublishAirdropCallback,
  useRecycleAirdropCallback
} from 'hooks/useAirdropCallback'
import { triggerSwitchChain } from 'utils/triggerSwitchChain'
import JSBI from 'jsbi'
import { useCurrencyBalance } from 'state/wallet/hooks'
import { ApprovalState, useApproveCallback } from 'hooks/useApproveCallback'
import { AIRDROP_ADDRESS } from '../../../constants'
import { Dots } from 'theme/components'
import useModal from 'hooks/useModal'
import TransacitonPendingModal from 'components/Modal/TransactionModals/TransactionPendingModal'
import MessageBox from 'components/Modal/TransactionModals/MessageBox'
import TransactiontionSubmittedModal from 'components/Modal/TransactionModals/TransactiontionSubmittedModal'
import { useUserHasSubmittedClaim } from 'state/transactions/hooks'
import { TokenAmount } from 'constants/token'
import { activityStatusText } from '../ActivityItem'
import { useGetDaoInfo } from 'hooks/useBackedDaoServer'

const PanelWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.borderRadius.default,
  boxShadow: theme.boxShadow.bs2,
  padding: '32px'
}))

const StyledText1 = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.text.secondary
}))

const StyledText2 = styled(StyledText1)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.primary
}))

const StyledText3 = styled(StyledText2)(() => ({
  fontWeight: 500
}))

export default function Airdrop() {
  const theme = useTheme()
  const { account, chainId, library } = useActiveWeb3React()
  const { showModal, hideModal } = useModal()
  const { daoId: curDaoId, id } = useParams<{ daoId: string; id: string }>()
  const airdropId = Number(id)
  const daoId = Number(curDaoId)
  const createDaoData = useGetDaoInfo(daoId)

  const [showManage, setShowManage] = useState(false)
  const { loading: airdropDescDataLoading, result: airdropDescData } = useGetAirdropDescData(airdropId)
  const airdropInfos = useAirdropInfos(airdropId, airdropDescData?.tokenChainId)
  console.log('🚀 ~ file: Airdrop.tsx:85 ~ Airdrop ~ airdropInfos:', airdropId, airdropDescData?.tokenChainId)
  const isClaimed = useAirdropClaimed(airdropId, airdropDescData?.tokenChainId)

  useEffect(() => {
    if (!account || !airdropDescData || account !== airdropDescData.creator) {
      setShowManage(false)
    }
  }, [account, airdropDescData])

  const { result: airdropProof } = useGetAirdropProof(
    airdropDescData?.status === ActivityStatus.AIRDROP ? airdropId : undefined,
    airdropInfos?.airdropToken
  )
  const claimAirdropCallback = useClaimAirdropCallback()
  const recycleAirdropCallback = useRecycleAirdropCallback()
  const remainderRecycle = useMemo(() => {
    if (!airdropInfos) return undefined
    return airdropInfos.tokenStaked.subtract(airdropInfos.tokenClaimed)
  }, [airdropInfos])
  const { claimSubmitted: isClaiming } = useUserHasSubmittedClaim(`${account}_claim_airdrop_${airdropId}`)
  const { claimSubmitted: isRecycling } = useUserHasSubmittedClaim(`${account}_recycle_airdrop_${airdropId}`)

  const claimAirdrop = useCallback(() => {
    if (!airdropProof) return
    showModal(<TransacitonPendingModal />)

    claimAirdropCallback(airdropId, airdropProof.index, airdropProof.amount.raw.toString(), airdropProof.proof)
      .then(hash => {
        hideModal()
        showModal(<TransactiontionSubmittedModal hash={hash} />)
      })
      .catch((err: any) => {
        hideModal()
        showModal(
          <MessageBox type="error">
            {err?.reason || err?.data?.message || err?.error?.message || err?.message || 'unknown error'}
          </MessageBox>
        )
        console.error(err)
      })
  }, [airdropId, airdropProof, claimAirdropCallback, hideModal, showModal])

  const recycleAirdrop = useCallback(() => {
    showModal(<TransacitonPendingModal />)

    recycleAirdropCallback(airdropId)
      .then(hash => {
        hideModal()
        showModal(<TransactiontionSubmittedModal hash={hash} />)
      })
      .catch((err: any) => {
        hideModal()
        showModal(
          <MessageBox type="error">
            {err?.reason || err?.data?.message || err?.error?.message || err?.message || 'unknown error'}
          </MessageBox>
        )
        console.error(err)
      })
  }, [airdropId, hideModal, recycleAirdropCallback, showModal])

  const claimBtn: { disabled: boolean; handler?: () => void; text?: string } = useMemo(() => {
    if (!airdropDescData || isClaimed === undefined) return { disabled: true }
    if (airdropDescData.status !== ActivityStatus.AIRDROP) {
      return { disabled: true }
    }
    if (isClaimed) {
      return {
        disabled: true,
        text: 'Claimed'
      }
    }
    if (isClaiming) {
      return {
        disabled: true,
        text: 'Claiming'
      }
    }
    if (airdropDescData.tokenChainId !== chainId)
      return {
        disabled: false,
        handler: () => triggerSwitchChain(library, airdropDescData.tokenChainId, account || '')
      }
    return {
      disabled: false,
      handler: claimAirdrop
    }
  }, [account, airdropDescData, chainId, claimAirdrop, isClaimed, isClaiming, library])

  const recycleBtn: { disabled: boolean; handler?: () => void; text?: string } = useMemo(() => {
    if (!airdropDescData) return { disabled: true }
    if (airdropDescData.status !== ActivityStatus.CLOSED) {
      return { disabled: true }
    }
    if (!remainderRecycle || !remainderRecycle.greaterThan(JSBI.BigInt(0))) {
      return {
        disabled: true,
        text: 'End'
      }
    }
    if (isRecycling) {
      return {
        disabled: true,
        text: 'Recycling'
      }
    }
    if (airdropDescData.tokenChainId !== chainId)
      return {
        disabled: false,
        handler: () => triggerSwitchChain(library, airdropDescData?.tokenChainId, account || '')
      }
    return {
      disabled: false,
      handler: recycleAirdrop
    }
  }, [account, airdropDescData, chainId, isRecycling, library, recycleAirdrop, remainderRecycle])

  return (
    <Box
      sx={{
        padding: { sm: '30px 20px', xs: '0 16px 30px' }
      }}
    >
      {airdropDescDataLoading ? (
        <DelayLoading loading={airdropDescDataLoading}>
          <Loading sx={{ marginTop: 30 }} />
        </DelayLoading>
      ) : (
        <ContainerWrapper maxWidth={1150}>
          {!showManage ? (
            <Stack spacing={40}>
              <Back sx={{ margin: '0 !important' }} />
              <Box>
                <Grid container spacing={40}>
                  <Grid item md={7} xs={12}>
                    <Box>
                      <Typography sx={{ width: '100%', wordWrap: 'break-word' }} fontSize={20} fontWeight={600}>
                        {airdropDescData?.title}
                      </Typography>
                      <Box mt={20} className="ql-editor">
                        {ReactHtmlParser(
                          filterXSS(airdropDescData?.description || '', {
                            onIgnoreTagAttr: function (_, name, value) {
                              if (name === 'class' || name === 'style') {
                                return name + '="' + escapeAttrValue(value) + '"'
                              }
                              return undefined
                            }
                          })
                        )}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item md={5} xs={12}>
                    {account && account === airdropInfos?.creator && (
                      <OutlineButton
                        noBold
                        style={{ marginBottom: 16 }}
                        height={48}
                        onClick={() => setShowManage(true)}
                      >
                        Manage
                      </OutlineButton>
                    )}

                    <PanelWrapper>
                      <Stack spacing={10}>
                        <RowCenter>
                          <StyledText1>Clique Rewards Token</StyledText1>
                          <MuiLink
                            target={'_blank'}
                            underline="none"
                            href={
                              airdropDescData && !isZero(airdropDescData.tokenAddress)
                                ? getEtherscanLink(
                                    airdropDescData.tokenChainId,
                                    airdropDescData.tokenAddress,
                                    'address'
                                  )
                                : undefined
                            }
                          >
                            <StyledText2>
                              {airdropInfos
                                ? airdropInfos.airdropToken.name + `(${airdropInfos.airdropToken.symbol})`
                                : '--'}
                            </StyledText2>
                          </MuiLink>
                        </RowCenter>
                        <RowCenter>
                          <StyledText1>Blockchain</StyledText1>
                          <StyledText2>
                            {airdropDescData?.tokenChainId ? ChainListMap[airdropDescData.tokenChainId]?.name : '--'}
                          </StyledText2>
                        </RowCenter>
                        <RowCenter>
                          <StyledText1>Contract Address</StyledText1>
                          <StyledText2 display={'flex'} alignItems="center">
                            {airdropInfos?.tokenAddress && !isZero(airdropInfos.tokenAddress) ? (
                              <>
                                {shortenAddress(airdropInfos.tokenAddress)}
                                <Copy margin="0 0 0 10px" toCopy={airdropInfos?.tokenAddress} />
                              </>
                            ) : (
                              '--'
                            )}
                          </StyledText2>
                        </RowCenter>
                        <RowCenter>
                          <StyledText1>Project Sponsors</StyledText1>
                          <StyledText2>
                            <Link
                              style={{ textDecoration: 'none' }}
                              to={airdropInfos?.creator ? routes._Profile + `/${airdropInfos.creator}` : ''}
                            >
                              {airdropInfos?.creator ? shortenAddress(airdropInfos.creator) : '--'}
                            </Link>
                          </StyledText2>
                        </RowCenter>

                        <RowCenter>
                          <StyledText1>DAO</StyledText1>
                          <StyledText2>
                            <Link style={{ textDecoration: 'none' }} to={routes._DaoInfo + `/${daoId}/proposal`}>
                              {createDaoData?.daoName || '--'}
                            </Link>
                          </StyledText2>
                        </RowCenter>
                      </Stack>
                    </PanelWrapper>

                    <PanelWrapper mt={20}>
                      <Stack spacing={10}>
                        <RowCenter>
                          <StyledText1>Status</StyledText1>
                          <StyledText2 style={{ color: theme.palette.primary.main }}>
                            {airdropDescData ? activityStatusText[airdropDescData.status] : '-'}
                          </StyledText2>
                        </RowCenter>
                        <RowCenter flexWrap={'wrap'}>
                          <StyledText1>Event Time</StyledText1>
                          <StyledText2 style={{ fontSize: 12 }} textAlign="right">
                            {airdropDescData
                              ? timeStampToFormat(airdropDescData.eventStartTime, 'Y-MM-DD HH:mm') +
                                ' - ' +
                                timeStampToFormat(airdropDescData.eventEndTime, 'Y-MM-DD HH:mm')
                              : '--'}
                          </StyledText2>
                        </RowCenter>
                        <RowCenter flexWrap={'wrap'}>
                          <StyledText1>Clique Rewards Time</StyledText1>
                          <StyledText2 style={{ fontSize: 12 }} textAlign="right">
                            {airdropInfos
                              ? timeStampToFormat(airdropInfos.airdropStartTime, 'Y-MM-DD HH:mm') +
                                ' - ' +
                                timeStampToFormat(airdropInfos.airdropEndTime, 'Y-MM-DD HH:mm')
                              : '--'}
                          </StyledText2>
                        </RowCenter>

                        <RowCenter>
                          <StyledText1>Total Clique Rewards</StyledText1>
                          <StyledText2>
                            {airdropInfos
                              ? airdropInfos.tokenStaked.toSignificant(6, { groupSeparator: ',' }) +
                                ` ${airdropInfos.airdropToken.symbol}`
                              : '--'}
                          </StyledText2>
                        </RowCenter>

                        <RowCenter>
                          <StyledText1>Addresses</StyledText1>
                          <StyledText2>{airdropDescData?.addressNum || '--'}</StyledText2>
                        </RowCenter>

                        {airdropDescData?.status === ActivityStatus.ACTIVE ||
                        airdropDescData?.status === ActivityStatus.ENDED ? (
                          <Box display={'flex'} flexDirection="row-reverse">
                            <BlackButton
                              width="98px"
                              height="24px"
                              disabled={!account || airdropDescData?.status === ActivityStatus.ENDED}
                              onClick={() =>
                                account &&
                                airdropDescData.collect &&
                                showModal(
                                  <AirdropCollectModal airdropId={airdropId} collect={airdropDescData.collect} />
                                )
                              }
                            >
                              {ActivityStatus.ENDED === airdropDescData.status ? ActivityStatus.ENDED : 'Join'}
                            </BlackButton>
                          </Box>
                        ) : airdropDescData?.status === ActivityStatus.AIRDROP ? (
                          <>
                            {airdropProof?.amount.greaterThan(JSBI.BigInt(0)) ? (
                              <Box>
                                <StyledText1>Claimable tokens</StyledText1>
                                <RowCenter>
                                  <StyledText2>
                                    {airdropProof?.amount.toSignificant(6, { groupSeparator: ',' })}{' '}
                                    {airdropInfos?.airdropToken.symbol}
                                  </StyledText2>
                                  <BlackButton
                                    style={{ borderWidth: 1, fontWeight: 500 }}
                                    fontSize={12}
                                    width={'125px'}
                                    height={'24px'}
                                    disabled={claimBtn.disabled}
                                    onClick={claimBtn.handler}
                                  >
                                    {claimBtn.text || 'Claim'}
                                  </BlackButton>
                                </RowCenter>
                              </Box>
                            ) : (
                              <Typography textAlign={'center'} fontSize={12} color={theme.palette.error.main}>
                                You are not on the whitelist
                              </Typography>
                            )}
                          </>
                        ) : airdropDescData?.status === ActivityStatus.CLOSED &&
                          airdropInfos?.creator === account &&
                          account ? (
                          <Box>
                            <StyledText1>Recycle Clique Rewards</StyledText1>
                            <RowCenter>
                              <StyledText2>
                                {remainderRecycle?.toSignificant(6, { groupSeparator: ',' })}{' '}
                                {airdropInfos?.airdropToken.symbol}
                              </StyledText2>
                              <BlackButton
                                style={{ borderWidth: 1, fontWeight: 500 }}
                                fontSize={12}
                                width={'125px'}
                                height={'24px'}
                                disabled={recycleBtn.disabled}
                                onClick={recycleBtn.handler}
                              >
                                {recycleBtn.text || 'Recycle'}
                              </BlackButton>
                            </RowCenter>
                          </Box>
                        ) : null}
                      </Stack>
                    </PanelWrapper>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
          ) : (
            <Box>
              <Back sx={{ margin: '0 !important' }} event={() => setShowManage(false)} />
              {airdropInfos && airdropDescData && (
                <ManageLoading
                  airdropInfo={airdropInfos}
                  airdropChainId={airdropDescData.tokenChainId}
                  daoId={daoId}
                  collectCount={airdropDescData.collectCount}
                />
              )}
            </Box>
          )}
        </ContainerWrapper>
      )}
    </Box>
  )
}

function ManageLoading({
  airdropInfo,
  airdropChainId,
  daoId,
  collectCount
}: {
  airdropInfo: AirdropInfoProp
  daoId: number
  airdropChainId: ChainId
  collectCount: number
}) {
  const { result } = useAirdropAccountListById(airdropInfo.airdropId, airdropInfo.airdropToken)
  const list = useMemo(() => {
    if (!result) return undefined
    return result.map(item => ({
      address: item.address,
      amount: item.amount.toSignificant(18)
    }))
  }, [result])

  return !list ? (
    <DelayLoading loading={!list}>
      <Loading sx={{ marginTop: 30 }} />
    </DelayLoading>
  ) : (
    <Manage
      defaultList={list}
      airdropInfo={airdropInfo}
      airdropChainId={airdropChainId}
      daoId={daoId}
      collectCount={collectCount}
    />
  )
}

function Manage({
  airdropInfo,
  airdropChainId,
  daoId,
  collectCount,
  defaultList
}: {
  airdropInfo: AirdropInfoProp
  daoId: number
  airdropChainId: ChainId
  collectCount: number
  defaultList: { address: string; amount: string }[]
}) {
  const [airdropList, setAirdropList] = useState<{ address: string; amount: string }[]>(defaultList)
  const airdropDownloadCallback = useAirdropDownloadCallback()
  const publishAirdropCallback = usePublishAirdropCallback()
  const { library, chainId, account } = useActiveWeb3React()
  const { showModal, hideModal } = useModal()
  const isEth = useMemo(() => isZero(airdropInfo.airdropToken.address), [airdropInfo.airdropToken.address])
  const { claimSubmitted: isPublishing } = useUserHasSubmittedClaim(`publish_airdrop_${airdropInfo.airdropId}`)

  const _totalInputAmount = useMemo(() => {
    let _count = new BigNumber(0)
    for (const item of airdropList) {
      _count = _count.plus(item.amount)
    }
    return _count.toString()
  }, [airdropList])
  const airdropTotalAmount = tryParseAmount(_totalInputAmount, airdropInfo.airdropToken)
  const needStake = useMemo(() => {
    if (!airdropTotalAmount) return undefined
    if (airdropTotalAmount.greaterThan(airdropInfo.tokenStaked)) {
      return airdropTotalAmount.subtract(airdropInfo.tokenStaked)
    }
    return new TokenAmount(airdropInfo.airdropToken, JSBI.BigInt(0))
  }, [airdropInfo.airdropToken, airdropInfo.tokenStaked, airdropTotalAmount])

  const [approveState, approveCallback] = useApproveCallback(needStake, AIRDROP_ADDRESS[airdropChainId], isEth)
  const airdropTokenBalance = useCurrencyBalance(account || undefined, airdropInfo.airdropToken, airdropChainId)
  const isAirdropped = useMemo(() => !!Number(airdropInfo.merkleRoot), [airdropInfo.merkleRoot])

  const toPublishAirdrop = useCallback(() => {
    if (!airdropTotalAmount || !needStake) return
    showModal(<TransacitonPendingModal />)

    publishAirdropCallback(
      isEth,
      airdropInfo.airdropId,
      airdropTotalAmount.raw.toString(),
      airdropInfo.airdropToken,
      needStake,
      airdropList,
      daoId
    )
      .then(hash => {
        hideModal()
        showModal(<TransactiontionSubmittedModal hash={hash} />)
      })
      .catch((err: any) => {
        hideModal()
        showModal(
          <MessageBox type="error">
            {err?.reason || err?.data?.message || err?.error?.message || err?.message || 'unknown error'}
          </MessageBox>
        )
        console.error(err)
      })
  }, [
    airdropInfo.airdropId,
    airdropInfo.airdropToken,
    airdropList,
    airdropTotalAmount,
    daoId,
    hideModal,
    isEth,
    needStake,
    publishAirdropCallback,
    showModal
  ])

  const paramsCheck: {
    disabled: boolean
    handler?: () => void
    error?: undefined | string | JSX.Element
  } = useMemo(() => {
    if (airdropList.length === 0) {
      return {
        disabled: true,
        error: 'Clique Rewards addresses required'
      }
    }
    if (!airdropTotalAmount || airdropTotalAmount.equalTo(JSBI.BigInt(0))) {
      return {
        disabled: true,
        error: 'Clique Rewards amount required'
      }
    }
    if (!needStake || !airdropTokenBalance) {
      return {
        disabled: true,
        error: 'Clique Rewards token balance loading'
      }
    }
    if (needStake.greaterThan(JSBI.BigInt(0)) && airdropTokenBalance.lessThan(airdropTotalAmount)) {
      return {
        disabled: true,
        error: 'Clique Rewards insufficient balance'
      }
    }

    if (airdropChainId !== chainId) {
      return {
        disabled: true,
        error: (
          <>
            You need{' '}
            <MuiLink
              sx={{ cursor: 'pointer' }}
              onClick={() => airdropChainId && triggerSwitchChain(library, airdropChainId, account || '')}
            >
              switch
            </MuiLink>{' '}
            to {ChainListMap[airdropChainId].name}
          </>
        )
      }
    }

    if (approveState !== ApprovalState.APPROVED) {
      if (approveState === ApprovalState.PENDING) {
        return {
          disabled: true,
          error: (
            <>
              Approving
              <Dots />
            </>
          )
        }
      } else if (approveState === ApprovalState.NOT_APPROVED) {
        return {
          disabled: true,
          error: (
            <>
              You need to{' '}
              <MuiLink sx={{ cursor: 'pointer' }} onClick={approveCallback}>
                approve
              </MuiLink>{' '}
              the contract to use your token.
            </>
          )
        }
      } else {
        return {
          disabled: true,
          error: (
            <>
              Loading
              <Dots />
            </>
          )
        }
      }
    }

    return {
      disabled: false
    }
  }, [
    account,
    airdropList.length,
    airdropTokenBalance,
    airdropTotalAmount,
    approveCallback,
    approveState,
    chainId,
    airdropChainId,
    library,
    needStake
  ])

  return (
    <ContainerWrapper maxWidth={708} margin="0">
      <Stack mt={20} spacing={20}>
        <RowCenter flexWrap={'wrap'}>
          <StyledText1>User data (original)</StyledText1>
          <RowCenter>
            <StyledText3 mr={15}>Total addresses: {collectCount}</StyledText3>
            <OutlineButton
              onClick={() => airdropDownloadCallback(airdropInfo.airdropId)}
              height="20px"
              fontWeight={500}
              fontSize={12}
              style={{ borderWidth: 1, padding: '0 6px', width: 'auto' }}
            >
              Download User Data <DownloadIcon sx={{ height: 16 }} />
            </OutlineButton>
          </RowCenter>
        </RowCenter>

        <AirdropTable
          readonly={isAirdropped || isPublishing}
          airdropList={airdropList}
          setAirdropList={(val: { address: string; amount: string }[]) => setAirdropList(val)}
          totalInputAmount={_totalInputAmount}
        />

        <RowCenter flexWrap={'wrap'}>
          <StyledText3 mr={10}>
            Contract balance: {airdropInfo.tokenStaked.toSignificant(6, { groupSeparator: ',' })}{' '}
            {airdropInfo.airdropToken.symbol}
          </StyledText3>
          <StyledText3>
            You balance: {airdropTokenBalance?.toSignificant(6, { groupSeparator: ',' }) || '--'}{' '}
            {airdropInfo.airdropToken.symbol}
          </StyledText3>
        </RowCenter>

        <StyledText3>
          You need transfer: {needStake?.toSignificant(6, { groupSeparator: ',' }) || '--'}{' '}
          {airdropInfo.airdropToken.symbol}
        </StyledText3>

        {paramsCheck.error ? (
          <Alert severity="error" sx={{ marginTop: 20 }}>
            {paramsCheck.error}
          </Alert>
        ) : isAirdropped ? null : (
          <Alert severity="success" sx={{ marginTop: 20 }}>
            You can now publish Clique Rewards
          </Alert>
        )}

        <Box display={'flex'} justifyContent="center">
          {isAirdropped ? (
            <BlackButton disabled width="160px" height="48px">
              Published
            </BlackButton>
          ) : (
            <BlackButton
              disabled={paramsCheck.disabled || isPublishing}
              onClick={toPublishAirdrop}
              width="160px"
              height="48px"
            >
              {isPublishing ? (
                <>
                  Publish now
                  <Dots />
                </>
              ) : (
                'Publish now'
              )}
            </BlackButton>
          )}
        </Box>
      </Stack>
    </ContainerWrapper>
  )
}
